module.exports = __webpack_public_path__ + "assets/img/DS-study (1).6a42a72d.jpg";